import * as React from 'react';
import Container from '@mui/material/Container';
import Grid, { GridProps } from '@mui/material/Grid';
import theme from '../theme/index';

const GlobalGrid: React.FC<GridProps> = ({ children, maxWidth, ...props }) => (
  <Container
    maxWidth={false}
    sx={{ maxWidth: maxWidth ?? theme.breakpoints.values.xl }}
  >
    <Grid
      container
      spacing={{ xs: 2, md: 3, lg: 4 }}
      columns={{ xs: 4, sm: 8, lg: 12 }}
      {...props}
    >
      {children}
    </Grid>
  </Container>
);

export default GlobalGrid;
